<template>
  <div
    id="app"
    :class="{
      'menu-open': $store.state.menu.open,
      'page-white': $store.state.color === 'white',
      'page-black': $store.state.color === 'black',
    }"
  >
    <MainSlider />

    <div class="view-container" ref="container">
      <div class="view-inner" v-if="loaded">
        <transition
          @enter="enterRoute"
          @leave="leaveRoute"
          appear
          mode="in-out"
          :css="false"
        >
          <router-view ref="view" :key="$store.state.route.fullPath" />
        </transition>
      </div>
    </div>

    <StaticFrame />

    <Loader />

    <Cookiebar
      class="app__cookie"
    >
      <CookieContent
        slot="content"
        text=""
        url="http://zonin1821.it/cookie/"
        label="Questo sito utilizza i <span class='cookie__label'>Cookie</span> per migliorare l'esperienza di navigazione."
      />
      <CookieButton
        slot="button"
        label="Accetta"
      />
    </Cookiebar>

    <CursorContainer ref="cursor" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import cursor from './scripts/cursor';
import scroll from './scripts/scroll';
import engine from './scripts/engine';
import MainSlider from '@/components/slider/MainSlider.vue';
import CursorContainer from '@/components/CursorContainer.vue';
import StaticFrame from '@/components/frame/StaticFrame.vue';
import Loader from '@/components/Loader.vue';
import animations from './assets/animations';
import demetra from './scripts/demetra';
import medusa from './scripts/medusa';
import Cookiebar from '@/components/Cookie/index.vue';
import CookieContent from '@/components/Cookie/CookieContent/index.vue';
import CookieButton from '@/components/Cookie/CookieButton/index.vue';

export default {
  name: 'App',

  components: {
    MainSlider,
    CursorContainer,
    StaticFrame,
    Loader,
    Cookiebar,
    CookieContent,
    CookieButton,
  },

  computed: {
    ...mapGetters(['loaded']),
  },

  watch: {
    loaded(value) {
      if (value) this.$nextTick(this.init);
    },
  },

  created() {
    medusa.init();
    demetra.init(this.$store.state.lang);
  },

  mounted() {
    cursor.init(this.$refs.cursor.$el.querySelector('.cursor-element'));

    this.resize();
    window.addEventListener('resize', () => this.resize());
  },

  methods: {
    init() {
      scroll.init(this.$refs.container, this.$refs.view.$el);

      engine.start();
    },

    resize() {
      const vh = window.innerHeight * 0.01;
      const rw = Math.max(window.innerWidth / 1920, 0.7);
      const rh = Math.max(window.innerHeight / 1080, 0.7);
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      document.documentElement.style.setProperty('--rw', rw);
      document.documentElement.style.setProperty('--rh', rh);
    },

    enterRoute(element, done) {
      done();
      animations.get('enter-route')(element).eventCallback('onComplete', () => {
        this.$store.commit('SET_NAVIGATING', false);
      }).play();
    },

    leaveRoute(element, done) {
      animations.get('leave-route')(element).eventCallback('onComplete', () => {
        scroll.ref.scrollTo({ x: 0, y: 0 }, 0);
        done();
      }).play();
    },
  },
};
</script>


<style lang="scss">
@import '@/styles/base.scss';

.view-container {
  @extend %full;
  pointer-events: none;
  z-index: 1;
}

.view-inner {
  position: relative;
  width: 100%;
}

.view {
  position: absolute;
  width: 100%;
  pointer-events: auto;
  color: $color-dark;
  overflow: hidden;

  &.home {
    display: none;
  }
}

.app__cookie {
  z-index: 999;
}

.cookie__label {
  font-weight: bold;
  border-bottom: 1px solid #4E4E4E;
  padding-bottom: 8px;
}
</style>
